// CardThree - Sivakasi Market Price - Shri Thiruppathi Hariharan Crackers
import React, { useState, useEffect, useRef, useMemo } from "react";
import styled from "styled-components";
import {
  Container,
  Row,
  Col,
  Table as BootstrapTable,
  Modal,
  Offcanvas,
  Form,
  Spinner,
} from "react-bootstrap";
import "./cardthree.css";
import ProductCardTwo from "../cardtwo/ProductCardTwo";
import {
  FaPlay,
  FaShoppingCart,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaSearch,
  FaCheckCircle,
  FaTruck,
  FaClock,
  FaCalendarAlt,
  FaInfoCircle,
  FaExclamationTriangle,
} from "react-icons/fa";
import { Buttons, Close } from "../../components/Buttons/Buttons";
import { FaPlus, FaMinus } from "react-icons/fa6";
import PageTitle from "../../components/Buttons/PageTitle";
import { Forms, DropDowns } from "../../components/Forms";
import { PDFDownloadLink } from "@react-pdf/renderer";
import API_DOMAIN from "../../config/config";
import Bill from "../../pdf/Bill";

const CardThree = ({
  products,
  category,
  selectedProduct,
  totals,
  addToCart,
  setShowVideoModal,
  showVideoModal,
  updateQuantity,
  handleShowCart,
  handleCloseCart,
  showCart,
  handleClose,
  handleShow,
  show,
  removeProduct,
  cart,
  districtData,
  companydata,
  setCart,
  setting,
  banner,
}) => {
  const [checkout, setCheckOut] = useState(false);
  const [showEstimate, setShowEstimate] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [printData, setPrintData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMode, setViewMode] = useState("card");
  const carouselRef = useRef(null);

  const [alertModal, setAlertModal] = useState({
    show: false,
    title: "",
    message: "",
    type: "warning",
  });

  const showAlert = (title, message, type = "warning") => {
    setAlertModal({
      show: true,
      title,
      message,
      type,
    });
  };

  const closeAlert = () => {
    setAlertModal((prev) => ({ ...prev, show: false }));
  };

  const closeOut = () => setCheckOut(false);
  const showOut = () => setCheckOut(true);
  const closeModal = () => setShowEstimate(false);
  const showModal = () => setShowEstimate(true);

  const [formData, setFormData] = useState({
    state: "",
    city: "",
    name: "",
    email: "",
    mobile: "",
    address: "",
  });
  const [cityOptions, setCityOptions] = useState([]);

  const handleStateChange = (selectedOption) => {
    const state = selectedOption.value;
    setFormData((prevState) => ({
      ...prevState,
      state,
      city: "",
    }));

    const cities = districtData[state] || [];
    setCityOptions(cities.map((city) => ({ value: city, label: city })));
  };
  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleCityChange = (selectedOption) => {
    const city = selectedOption.value;
    setFormData((prevState) => ({
      ...prevState,
      city,
    }));
  };

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const categoryOptions = [
    { value: "all", label: "All" },
    ...category.map((cat) => ({
      value: cat.id,
      label: cat.category_name,
    })),
  ];

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption.value);
  };

  const handleCategoryImageClick = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  const getFirstProductImage = (categoryId) => {
    const categoryProducts = products.filter(
      (product) => product.category_id === categoryId
    );

    if (categoryProducts.length > 0) {
      const validProduct = categoryProducts.find((product) => product.img);
      return validProduct
        ? validProduct.img
        : require("../../assets/images/storelogo.png");
    }
  };

  const [showSuggestions, setShowSuggestions] = useState(false);

  const searchSuggestions = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return [];
    return products
      .filter(
        (p) =>
          p.active === 1 &&
          (p.product_name.toLowerCase().includes(q) ||
            (p.product_content || "").toLowerCase().includes(q))
      )
      .slice(0, 8);
  }, [products, searchQuery]);

  const filteredProducts = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();

    return products.filter((p) => {
      // Filter by category
      const categoryMatch =
        selectedCategory === "all" || p.category_id === selectedCategory;

      // Filter by search text
      const searchMatch =
        p.product_name.toLowerCase().includes(q) ||
        (p.product_content || "").toLowerCase().includes(q) ||
        String(p.price).includes(q);

      return categoryMatch && searchMatch;
    });
  }, [products, selectedCategory, searchQuery]);

  const handleSubmit = () => {
    if (!formData.state) {
      showAlert("State Required", "Please select your State to proceed with the estimate.", "warning");
      return;
    }
    if (!formData.name) {
      showAlert("Name Required", "Please enter your Name to proceed with the estimate.", "warning");
      return;
    }
    if (!formData.mobile) {
      showAlert("Mobile Number Required", "Please enter your Mobile Number.", "warning");
      return;
    }

    const minRequired = formData.state === "Tamil Nadu" ? 3000 : 5000;
    if (totals.discountRate < minRequired) {
      showAlert(
        "Minimum Order Requirement Not Met",
        `Minimum order required for ${formData.state} is ₹${minRequired.toLocaleString()}. Your current order total is ₹${totals.discountRate.toFixed(2)}. Please add ₹${(minRequired - totals.discountRate).toFixed(0)} more items to proceed.`,
        "warning"
      );
      return;
    }

    setIsSubmitting(true);

    fetch(`${API_DOMAIN}/online_enq_web.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cart_pro: cart,
        customer_data: formData,
        total_products: totals.totalProducts,
        total_price: totals.discountRate.toFixed(2),
        total_discount: totals.overallTotal.toFixed(2),
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setIsSubmitting(false);
        if (data.head.code === 200) {
          setPrintData(data.body.data);
          showModal();
          setCart([]);
          setFormData({
            state: "",
            city: "",
            name: "",
            email: "",
            mobile: "",
            address: "",
          });
          closeOut();
        } else {
          showAlert("Order Error", data.head.msg || "Order submission failed.", "danger");
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.error("Error submitting order:", error);
        showAlert("Connection Error", "Network error while submitting your order. Please try again.", "danger");
      });
  };

  const extractVideoId = (url) => {
    const urlObj = new URL(url);
    if (urlObj.hostname === "youtu.be") {
      return urlObj.pathname.slice(1);
    } else if (
      urlObj.hostname === "youtube.com" ||
      urlObj.hostname === "www.youtube.com"
    ) {
      return urlObj.searchParams.get("v") || urlObj.pathname.split("/").pop();
    }
    return "";
  };

  const handleVideoModalShow = () => {
    console.log("Showing video modal");
    setShowVideoModal(true);
  };

  const handleVideoModalClose = () => {
    console.log("Closing video modal");
    setShowVideoModal(false);
  };

  const actionvalue = "minus";

  return (
    <>
      {/* Unified Sticky Header: Search/Filters + Summary Stats Strip */}
      <div className="sticky-unified-header">
        <div className="top-control-bar-section">
          <Container fluid className="px-lg-4">
            {/* Top Control Bar: Search and Filters (50% / 50% split) */}
            <div className="top-control-bar">
              <div className="search-input-wrapper" style={{ position: "relative" }}>
                <input
                  type="text"
                  placeholder="Search an item..."
                  value={searchQuery}
                  onChange={(e) => {
                    handleSearchChange(e);
                    setShowSuggestions(true);
                  }}
                  onFocus={() => setShowSuggestions(true)}
                  onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                />
                {searchQuery ? (
                  <FaTimes
                    className="search-icon clear-search-icon"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSearchQuery("");
                      setShowSuggestions(false);
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSearchQuery("");
                      setShowSuggestions(false);
                    }}
                  />
                ) : (
                  <FaSearch className="search-icon" />
                )}

                {showSuggestions && searchQuery.trim() && searchSuggestions.length > 0 && (
                  <div
                    className="search-suggestions-dropdown"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: "#FFFFFF",
                      border: "2px solid #7B0F1C",
                      borderRadius: "0 0 10px 10px",
                      boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
                      zIndex: 1100,
                      maxHeight: "280px",
                      overflowY: "auto",
                      marginTop: "2px",
                    }}
                  >
                    {searchSuggestions.map((item) => (
                      <div
                        key={item.id}
                        className="suggestion-item p-2 border-bottom d-flex align-items-center justify-content-between"
                        style={{ cursor: "pointer", background: "#FFFFFF", transition: "background 0.2s" }}
                        onMouseDown={() => {
                          setSearchQuery(item.product_name);
                          setShowSuggestions(false);
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          {item.img && (
                            <img
                              src={item.img}
                              alt={item.product_name}
                              style={{ width: "32px", height: "32px", objectFit: "cover", borderRadius: "4px" }}
                            />
                          )}
                          <span className="fw-bold text-dark" style={{ fontSize: "0.85rem" }}>
                            {item.product_name}
                          </span>
                        </div>
                        <span className="badge bg-danger text-white ms-2" style={{ fontSize: "0.75rem" }}>
                          ₹{item.price}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="filter-dropdown-wrapper">
                <DropDowns
                  options={categoryOptions}
                  placeholder="Filters ▾"
                  value={
                    categoryOptions.find(
                      (opt) => opt.value === selectedCategory
                    ) || null
                  }
                  onChange={handleCategoryChange}
                />
              </div>
            </div>
          </Container>
        </div>

        {/* Top Sticky Summary Strip (Exact Screenshot Match) */}
        <div className="product-summary-strip">
          <Container fluid className="px-lg-4">
            <div className="summary-strip-card">
              <div className="summary-stats-group">
                <div className="summary-col">
                  <span className="summary-label">Total Products</span>
                  <span className="summary-val">: {totals.totalProducts}</span>
                </div>
                <div className="summary-col">
                  <span className="summary-label">Discount Total :</span>
                  <span className="summary-val">₹ {totals.discountRate.toFixed(2)}</span>
                </div>
                <div className="summary-col">
                  <span className="summary-label">Overall Total :</span>
                  <span className="summary-val">₹ {totals.overallTotal.toFixed(2)}</span>
                </div>
              </div>

              <div className="summary-actions">
                <div className="view-toggle-group">
                  <button
                    type="button"
                    className={`view-toggle-btn ${viewMode === "card" ? "active" : ""}`}
                    onClick={() => setViewMode("card")}
                    title="Card View"
                  >
                    🎴 Cards
                  </button>
                  <button
                    type="button"
                    className={`view-toggle-btn ${viewMode === "table" ? "active" : ""}`}
                    onClick={() => setViewMode("table")}
                    title="Table View"
                  >
                    📋 Table
                  </button>
                </div>
                <button
                  type="button"
                  className="summary-cart-btn"
                  onClick={handleShowCart}
                >
                  <FaShoppingCart className="me-1" />
                  <span>Cart ({totals.totalProducts})</span>
                </button>
              </div>
            </div>
          </Container>
        </div>
      </div>

      <div className="bg-grey py-3">
        <Container fluid className="px-lg-4">
          {viewMode === "card" ? (
            /* ================= CARD VIEW (Exact Screenshot Layout) ================= */
            <div className="product-cards-container mb-5">
              {category
                .filter((cat) => cat.website_active === 1)
                .map((cat) => {
                  const categoryProducts = filteredProducts.filter(
                    (product) =>
                      product.category_id === cat.id &&
                      product.active === 1
                  );
                  if (categoryProducts.length === 0) return null;

                  const catDiscount = cat.discount;

                  return (
                    <div className="category-card-section mb-4" key={cat.id}>
                      {/* Category Header Banner (Plum Bar) */}
                      <div className="category-card-banner mb-3">
                        <h5 className="category-card-title">
                          <span>{cat.category_name.toUpperCase()}</span>
                          {catDiscount && Number(catDiscount) > 0 ? (
                            <span className="cat-discount-badge">
                              ({catDiscount}% DISCOUNT)
                            </span>
                          ) : null}
                        </h5>
                      </div>

                      {/* Products 2-Column Responsive Card Grid */}
                      <Row className="g-3">
                        {categoryProducts.map((product, idx) => {
                          const hasDiscount =
                            product.discount_lock === 0 &&
                            catDiscount &&
                            Number(catDiscount) > 0;

                          const netPrice = hasDiscount
                            ? Math.round(
                              product.price -
                              (product.price * Number(catDiscount)) / 100
                            )
                            : Math.round(product.price);

                          const itemTotal = (
                            netPrice * (product.qty || 0)
                          ).toFixed(0);

                          return (
                            <Col xs={12} md={6} lg={6} key={product.id}>
                              <div className="custom-product-card">
                                {/* Top-Left Royal Blue Serial Badge */}
                                <div className="card-serial-badge">
                                  {idx + 1}
                                </div>

                                <div className="card-inner-flex">
                                  {/* Left: Product Image */}
                                  <div
                                    className="card-img-container"
                                    onClick={() => handleShow(product)}
                                    role="button"
                                    tabIndex={0}
                                    title="Click to view image"
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter" || e.key === " ") handleShow(product);
                                    }}
                                  >
                                    <img
                                      src={
                                        product.img
                                          ? product.img
                                          : require("../../assets/images/storelogo.png")
                                      }
                                      alt={product.product_name || product.name}
                                      loading="lazy"
                                    />
                                  </div>

                                  {/* Middle: Title & Price Details */}
                                  <div className="card-details-container">
                                    <h6
                                      className="card-item-title"
                                      title={product.product_name || product.name}
                                    >
                                      {product.product_name || product.name}
                                    </h6>
                                    <div className="card-price-rows">
                                      <div className="card-mrp-price">
                                        {hasDiscount ? (
                                          <del>
                                            ₹ {product.price}.00 / {product.product_content || "Box"}
                                          </del>
                                        ) : (
                                          <span>
                                            ₹ {product.price}.00 / {product.product_content || "Box"}
                                          </span>
                                        )}
                                      </div>
                                      <div className="card-net-price">
                                        ₹ {netPrice}.00 / {product.product_content || "Box"}
                                      </div>
                                    </div>
                                  </div>

                                  {/* Right: White Qty box + Attached Royal Blue Pill */}
                                  <div className="card-action-container">
                                    <div className="card-qty-wrapper">
                                      <div className="card-qty-field">
                                        <span className="card-qty-tag">Qty</span>
                                        <input
                                          type="number"
                                          min="0"
                                          className="card-qty-input"
                                          value={product.qty || ""}
                                          placeholder="0"
                                          onChange={(e) => {
                                            const val = parseInt(e.target.value) || 0;
                                            const diff = val - (product.qty || 0);
                                            if (diff !== 0) {
                                              updateQuantity(product.id, diff);
                                              addToCart({
                                                id: product.id,
                                                name:
                                                  product.product_name || product.name,
                                                total_price: product.price,
                                                qty: val,
                                                discount: cat.discount,
                                                category_id: product.category_id,
                                                per_price: netPrice,
                                                product_content:
                                                  product.product_content,
                                                img: product.img || null,
                                              });
                                            }
                                          }}
                                        />
                                      </div>
                                      <div className="card-price-pill">
                                        ₹ {product.qty > 0 ? itemTotal : 0}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                    </div>
                  );
                })}
            </div>
          ) : (
            /* ================= TABLE VIEW ================= */
            <div className="table-responsive px-1">
              <table className="custom-product-table">
                <thead>
                  <tr>
                    <th style={{ width: "11%" }}>Image</th>
                    <th style={{ width: "31%" }}>Product Name</th>
                    <th style={{ width: "16%" }}>Actual Price</th>
                    <th style={{ width: "12%" }}>Price</th>
                    <th style={{ width: "15%" }}>Quantity</th>
                    <th style={{ width: "15%" }}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {category
                    .filter((cat) => cat.website_active === 1)
                    .map((cat) => {
                      const categoryProducts = filteredProducts.filter(
                        (product) =>
                          product.category_id === cat.id &&
                          product.active === 1
                      );
                      if (categoryProducts.length === 0) return null;

                      const catDiscount = cat.discount;

                      return (
                        <React.Fragment key={cat.id}>
                          {/* Category Banner Row */}
                          <tr className="category-header-row">
                            <th colSpan="6">
                              {cat.category_name.toUpperCase()}
                              {catDiscount && Number(catDiscount) > 0
                                ? ` (${catDiscount}% DISCOUNT)`
                                : ""}
                            </th>
                          </tr>

                          {/* Product Data Rows */}
                          {categoryProducts.map((product) => {
                            const hasDiscount =
                              product.discount_lock === 0 &&
                              catDiscount &&
                              Number(catDiscount) > 0;

                            const netPrice = hasDiscount
                              ? Math.round(
                                product.price -
                                (product.price * Number(catDiscount)) / 100
                              )
                              : Math.round(product.price);

                            const itemTotal = (
                              netPrice * (product.qty || 0)
                            ).toFixed(0);

                            return (
                              <tr key={product.id}>
                                {/* Image Column */}
                                <td>
                                  <div
                                    className="product-img-box"
                                    onClick={() => handleShow(product)}
                                  >
                                    <img
                                      src={
                                        product.img
                                          ? product.img
                                          : require("../../assets/images/storelogo.png")
                                      }
                                      alt={product.product_name || product.name}
                                    />
                                  </div>
                                </td>

                                {/* Product Name Column */}
                                <td>
                                  <div className="fw-bold">
                                    {product.product_name || product.name}
                                  </div>
                                </td>

                                {/* Actual Price Column */}
                                <td>
                                  <div
                                    className={
                                      hasDiscount
                                        ? "actual-price-del"
                                        : "actual-price-normal"
                                    }
                                  >
                                    {product.price}.00
                                  </div>
                                  <div className="pack-unit-text">
                                    {product.product_content || "1Pkt"}
                                  </div>
                                </td>

                                {/* Price Column */}
                                <td>
                                  <span className="net-price-text">{netPrice}</span>
                                </td>

                                {/* Quantity Column */}
                                <td>
                                  <input
                                    type="number"
                                    min="0"
                                    className="qty-input-box"
                                    value={product.qty || ""}
                                    onChange={(e) => {
                                      const val = parseInt(e.target.value) || 0;
                                      const diff = val - (product.qty || 0);
                                      if (diff !== 0) {
                                        updateQuantity(product.id, diff);
                                        addToCart({
                                          id: product.id,
                                          name:
                                            product.product_name || product.name,
                                          total_price: product.price,
                                          qty: val,
                                          discount: cat.discount,
                                          category_id: product.category_id,
                                          per_price: netPrice,
                                          product_content:
                                            product.product_content,
                                          img: product.img || null,
                                        });
                                      }
                                    }}
                                  />
                                </td>

                                {/* Total Column */}
                                <td>
                                  <input
                                    type="text"
                                    className="total-input-box"
                                    value={product.qty > 0 ? itemTotal : ""}
                                    readOnly
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}
                </tbody>
              </table>
            </div>
          )}
        </Container>
      </div>

      {/* Floating Bottom Cart Pill */}
      <div className="floating-cart-bar" onClick={handleShowCart}>
        <span>
          {totals.totalProducts} items . ₹ {totals.discountRate.toFixed(2)}
        </span>
        <span className="mx-1">|</span>
        <span className="floating-cart-badge-container">
          <FaShoppingCart style={{ fontSize: "1.2rem" }} />
          {totals.totalProducts > 0 && (
            <span className="floating-cart-badge">{totals.totalProducts}</span>
          )}
        </span>
        <span>View Cart</span>
      </div>

      <>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <div className="regular">
                {" "}
                {selectedProduct && selectedProduct.name}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="mx-auto">
            <table>
              <tbody>
                <tr>
                  <td className="text-center image_video" colSpan="2">
                    <div className="text-center mx-auto w-25">
                      {selectedProduct &&
                        (selectedProduct.img ? (
                          <img
                            src={selectedProduct.img}
                            className="img-fluid"
                            alt="Product"
                          />
                        ) : (
                          <img
                            src={require("../../assets/images/storelogo.png")}
                            className="img-fluid"
                            alt="Product Placeholder"
                          />
                        ))}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <table>
              <tbody>
                <tr>
                  {selectedProduct && selectedProduct.img && (
                    <td>
                      <div className="dual">
                        <img
                          src={selectedProduct.img}
                          className="img-fluid"
                          alt="product"
                        />
                      </div>
                    </td>
                  )}
                  {selectedProduct && selectedProduct.video_url && (
                    <td>
                      <div className="w-25 mx-auto">
                        <div
                          className="play-icon"
                          onClick={handleVideoModalShow}
                        >
                          <FaPlay />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              </tbody>
            </table>
          </Modal.Footer>
        </Modal>
        {showVideoModal && (
          <Modal show={showVideoModal} onHide={handleVideoModalClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>
                {selectedProduct && selectedProduct.name}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <iframe
                width="100%"
                height="400"
                src={`https://www.youtube.com/embed/${extractVideoId(
                  selectedProduct.video_url
                )}`}
                frameBorder="0"
                allowFullScreen
                title="Product Video"
              />
            </Modal.Body>
          </Modal>
        )}
      </>
      {/* Product Modal end */}
      {/* cart table start */}
      <Offcanvas
        show={showCart}
        onHide={handleCloseCart}
        scroll="true"
        placement="end"
      >
        <PageTitle onClick={handleCloseCart} title={companydata.company_name} />
        <Offcanvas.Body>
          <div className="canvas-table regular">
            <div className="cart-table">
              <BootstrapTable>
                <tbody>
                  {cart.map((cart) => (
                    <tr key={cart.id}>
                      <td className="w-75">
                        <div className="product-name pb-1 fw-bold">{cart.name}</div>
                        <div className="d-flex align-items-center gap-1 mt-1">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger px-2 py-0 fw-bold"
                            style={{ minWidth: "28px" }}
                            onClick={() => {
                              if (cart.qty > 1) {
                                updateQuantity(cart.id, -1);
                                addToCart({
                                  id: cart.id,
                                  action: "minus",
                                });
                              } else {
                                removeProduct(cart.id);
                              }
                            }}
                          >
                            -
                          </button>
                          <input
                            className="form-control form-control-sm text-center fw-bold px-1"
                            style={{ width: "45px" }}
                            value={cart.qty}
                            readOnly
                          />
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-success px-2 py-0 fw-bold"
                            style={{ minWidth: "28px" }}
                            onClick={() => {
                              updateQuantity(cart.id, 1);
                              addToCart({
                                id: cart.id,
                                action: "plus",
                              });
                            }}
                          >
                            +
                          </button>
                        </div>
                      </td>
                      <td className="text-end">
                        <div className="pb-2">
                          {" "}
                          <Close
                            label={
                              <>
                                <FaTimes />
                              </>
                            }
                            onClick={() => removeProduct(cart.id)}
                          />{" "}
                        </div>
                        <div className="price_total">
                          ₹<span>{cart.total_price}</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </BootstrapTable>
            </div>
          </div>
          <div className="bottom-table">
            <BootstrapTable>
              <tr>
                <td>
                  <tr>
                    <td className="w-100"> Total Net Rate Amount :</td>
                    <td>
                      {" "}
                      ₹<span>{totals.overallTotal.toFixed(2)}</span>
                    </td>
                  </tr>
                </td>
              </tr>
              <tr>
                <td>
                  <tr>
                    <td className="w-100"> Total Discount Amount :</td>
                    <td>
                      {" "}
                      ₹<span>{totals.discountedOverallTotal.toFixed(2)}</span>
                    </td>
                  </tr>
                </td>
              </tr>
              <tr>
                <td>
                  <tr>
                    <td className="w-100"> Total Amount :</td>
                    <td>
                      {" "}
                      ₹<span>{totals.discountRate.toFixed(2)}</span>
                    </td>
                  </tr>
                </td>
              </tr>
            </BootstrapTable>
          </div>
          {/* Minimum Order Info Banner */}
          <div className="p-3 my-3 rounded-3" style={{ background: "linear-gradient(135deg, #FFFDF5 0%, #FFF8E7 100%)", border: "1px solid #FFE0B2" }}>
            <div className="fw-bold text-dark mb-2 text-center" style={{ fontSize: "0.9rem" }}>
              <FaInfoCircle className="text-warning me-1" /> Minimum Order Requirements
            </div>
            <div className="d-flex justify-content-center gap-2 flex-wrap text-center">
              <span className="badge bg-white text-danger border border-danger px-3 py-2 shadow-sm rounded-pill">
                Tamil Nadu: <strong>₹3,000</strong>
              </span>
              <span className="badge bg-white text-dark border border-secondary px-3 py-2 shadow-sm rounded-pill">
                Other States: <strong>₹5,000</strong>
              </span>
            </div>
          </div>

          <div className="text-center my-3">
            {totals.discountRate >= 3000 ? (
              <Buttons
                label={<>Confirm Estimate & Checkout ➔</>}
                fullWidth={"100%"}
                onClick={() => {
                  showOut();
                  handleCloseCart();
                }}
              ></Buttons>
            ) : (
              <div className="alert alert-warning py-2 px-3 mb-0 text-center fw-bold" style={{ fontSize: "0.85rem" }}>
                Add ₹{(3000 - totals.discountRate).toFixed(0)} more items to reach minimum order (₹3,000)
              </div>
            )}
          </div>

          {/* Terms and Conditions Section */}
          <div className="terms-section mt-4">
            <h5 className="bold"><FaCheckCircle className="me-2" /> Terms & Conditions</h5>
            <div className="terms-card-item">
              <FaCheckCircle className="text-success mt-1 flex-shrink-0" />
              <div>
                <strong>Minimum Order Value:</strong> Tamil Nadu - ₹3,000 | Other States - ₹5,000
              </div>
            </div>
            <div className="terms-card-item">
              <FaTruck className="text-primary mt-1 flex-shrink-0" />
              <div>
                <strong>Transportation Charges:</strong> Extra (as per actual parcel transport)
              </div>
            </div>
            <div className="terms-card-item">
              <FaClock className="text-warning mt-1 flex-shrink-0" />
              <div>
                <strong>Delivery Time:</strong> Tamil Nadu - 4 Days, Other States - 10 Days
              </div>
            </div>
            <div className="terms-card-item">
              <FaCalendarAlt className="text-danger mt-1 flex-shrink-0" />
              <div>
                <strong>Price List Validity:</strong> Valid for Diwali 2026 season
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      {/* cart table end */}
      {/* customer details start */}
      <>
        <Offcanvas show={checkout} scroll="true" placement="end">
          <PageTitle onClick={closeOut} title={companydata.company_name} />
          <Offcanvas.Body>
            <div className="customer-details regular" style={{ position: "relative", minHeight: "100%" }}>
              {isSubmitting && (
                <div
                  className="submitting-overlay"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.94)",
                    backdropFilter: "blur(5px)",
                    zIndex: 2000,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "24px",
                    textAlign: "center",
                    borderRadius: "12px",
                  }}
                >
                  <Spinner
                    animation="border"
                    style={{ width: "3.5rem", height: "3.5rem", color: "#7B0F1C", borderWidth: "4px" }}
                  />
                  <h5 className="mt-4 fw-bold" style={{ color: "#3D0710" }}>
                    Submitting Enquiry...
                  </h5>
                  <p className="text-muted small mb-0 px-2" style={{ maxWidth: "280px" }}>
                    Please wait while we process your cracker estimate and generate your order slip.
                  </p>
                </div>
              )}
              <div className="canvas-table regular">
                <Container>
                  <Row>
                    <Col lg="12" className="py-2">
                      <DropDowns
                        options={Object.keys(districtData).map((state) => ({
                          value: state,
                          label: state,
                        }))}
                        placeholder={"Select State"}
                        label={"Select State"}
                        name="state"
                        value={{ value: formData.state, label: formData.state }}
                        onChange={handleStateChange}
                      />
                    </Col>
                    <Col lg="12" className="py-2">
                      <Forms
                        placeholder={"Enter City / District"}
                        label={"Enter City / District"}
                        name="city"
                        value={formData.city || ""}
                        onChange={(e) => handleChange(e, "city")}
                      />
                    </Col>
                    <Col lg="12" className="py-2">
                      <Forms
                        placeholder={"Enter the name"}
                        label={"Enter the Name"}
                        name="name"
                        value={formData.name}
                        onChange={(e) => handleChange(e, "name")}
                      />
                    </Col>
                    <Col lg="12" className="py-2">
                      <Forms
                        placeholder={"Enter the Mail"}
                        label={"Enter the Mail"}
                        name="email"
                        value={formData.email}
                        onChange={(e) => handleChange(e, "email")}
                      />
                    </Col>
                    <Col lg="12" className="py-2">
                      <Forms
                        placeholder={"Mobile No."}
                        label={"Mobile No."}
                        name="mobile"
                        value={formData.mobile}
                        onChange={(e) => handleChange(e, "mobile")}
                      />
                    </Col>
                    <Col lg="12" className="py-2">
                      <div className="py-2">
                        {" "}
                        <label> Address</label>
                      </div>
                      <textarea
                        placeholder="Address"
                        className="w-100"
                        name="address"
                        value={formData.address}
                        onChange={(e) => handleChange(e, "address")}
                      />
                    </Col>
                  </Row>
                </Container>
              </div>
              <div className="bottom-table">
                <BootstrapTable>
                  <tr>
                    <td>
                      <tr>
                        <td className="w-100"> Total Net Rate Amount :</td>
                        <td>
                          {" "}
                          ₹<span>{totals.overallTotal.toFixed(2)}</span>
                        </td>
                      </tr>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <tr>
                        <td className="w-100"> Total Discount Amount :</td>
                        <td>
                          {" "}
                          ₹<span>{totals.discountedOverallTotal.toFixed(2)}</span>
                        </td>
                      </tr>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <tr>
                        <td className="w-100"> Total Amount :</td>
                        <td>
                          {" "}
                          ₹<span>{totals.discountRate.toFixed(2)}</span>
                        </td>
                      </tr>
                    </td>
                  </tr>
                </BootstrapTable>
              </div>
              <div className="d-flex justify-content-evenly">
                <div className="text-center regular py-3 w-100 mx-2">
                  <Buttons
                    label={
                      isSubmitting ? (
                        <span className="d-inline-flex align-items-center justify-content-center">
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          Submitting...
                        </span>
                      ) : (
                        <>Submit</>
                      )
                    }
                    className="w-100"
                    fullWidth={"100%"}
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  ></Buttons>
                </div>
                <div className="text-center regular py-3 w-100 mx-2">
                  <Buttons
                    label={<>Cancel</>}
                    fullWidth={"100%"}
                    onClick={closeOut}
                    disabled={isSubmitting}
                  ></Buttons>
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </>
      {/* customer details end */}
      {/* order preview modal start*/}
      <>
        <Modal
          show={showEstimate}
          onClick={closeModal}
          centered
          className="regular"
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title className="bold">Order Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container fluid>
              <Row>
                <Col lg="12">
                  <div className="text-center py-3">
                    <div> {companydata.company_name}</div>
                    <div>{companydata.address}</div>
                    <div> Phone No :{companydata.phone}</div>
                  </div>
                  <div className="text-center">Estimated Successfully</div>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <PDFDownloadLink
              document={<Bill data={printData} />}
              fileName="estimate.pdf"
            >
              <Buttons label={<>Download PDF</>} onClick={closeModal} />
            </PDFDownloadLink>
          </Modal.Footer>
        </Modal>
      </>


      {/* Professional Customer Alert Modal */}
      <Modal
        show={alertModal.show}
        onHide={closeAlert}
        centered
        backdrop="static"
        keyboard={true}
        className="regular"
        size="md"
      >
        <div style={{ borderRadius: "14px", overflow: "hidden", border: "1px solid #FFE0B2" }}>
          <div
            className="p-3 text-white text-center d-flex align-items-center justify-content-center gap-2"
            style={{
              background: alertModal.type === "danger"
                ? "linear-gradient(135deg, #D32F2F 0%, #C0392B 100%)"
                : "linear-gradient(135deg, #800000 0%, #900C3F 100%)",
            }}
          >
            <FaExclamationTriangle style={{ fontSize: "1.4rem", color: "#F4B942" }} />
            <h5 className="m-0 fw-bold">{alertModal.title}</h5>
          </div>
          <Modal.Body className="p-4 text-center">
            <p className="mb-0 text-dark fw-bold" style={{ fontSize: "1.05rem", lineHeight: "1.6" }}>
              {alertModal.message}
            </p>
          </Modal.Body>
          <Modal.Footer className="justify-content-center border-0 pb-4 pt-0">
            <button
              type="button"
              className="btn text-white fw-bold px-4 py-2"
              style={{
                background: "linear-gradient(135deg, #800000 0%, #900C3F 100%)",
                borderRadius: "25px",
                minWidth: "160px",
                boxShadow: "0 4px 12px rgba(128, 0, 0, 0.3)",
              }}
              onClick={closeAlert}
            >
              Continue Shopping 🛒
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default CardThree;

const StyledTable = styled(BootstrapTable)`
  margin-bottom: 0 !important;
  background-color: #7B0F1C;
  border: 0;
  border-color: #7B0F1C;
  color: #fff;
  font-family: "regular";
  & th,
  & td {
    text-align: center;
    background-color: #7B0F1C;
    vertical-align: middle;
    color: #fff;
  }
`;
const Category = styled.div`
  background-color: #3D0710;
  border: 0;
  border-color: #3D0710;
  color: white;
  text-align: center;
  padding: 10px 0;
  font-size: 18px;
  font-family: "bold";
`;
const Calc = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Input = styled.input`
  border: none;
  outline: none;
  padding: 4px;
  width: 60px;
  text-align: center;
  background: transparent;
`;
